import React from "react";
import GroupSection from "../GroupSection";
import PaginationModel from "~/common/Store/models/Pagination";
import ProductListing from "~/productListing/ProductListing";
import { FacetNavigation } from "~/productListing/Sidebar/Filters";
import { PageCreatorGroupModel } from "../Models/PageCreatorPage";
import { Product } from "~/common/Store/models/ProductListing";
import FeatureFlagProvider from "~/common/contexts/FeatureFlagProvider";
import PageResult from "~/common/types/PageResult";

interface Props extends PageResult {
  activeEndDate: string;
  activeStartDate: string;
  couponCode: string;
  facetNavigation: FacetNavigation;
  headerGroup: PageCreatorGroupModel;
  pageName: string;
  pagination: PaginationModel;
  products: Product[];
  rawClientUrl: string;
}

export default ({
  featureFlags,
  activeEndDate,
  activeStartDate,
  couponCode,
  facetNavigation,
  headerGroup,
  pageName,
  pagination,
  products,
  rawClientUrl,
}: Props) => {
  return (
    <FeatureFlagProvider featureFlags={featureFlags}>
      <div
        data-module="initPageCreatorItemListingPage"
        className="flex flex-col w-full"
      >
        {headerGroup && headerGroup.sections.length > 0 && (
          <>
            {headerGroup.sections.map((section) => (
              <GroupSection
                activeEndDate={activeEndDate}
                activeStartDate={activeStartDate}
                couponCode={couponCode}
                isItemListingPage
                key={section.sortOrder}
                section={section}
              />
            ))}
          </>
        )}
        <ProductListing
          discountCode={couponCode}
          facetNavigation={facetNavigation}
          hasBackground={false}
          hasHeaderData={false}
          hideFilters={false}
          pageName={pageName}
          pageUrl={rawClientUrl}
          pagination={pagination}
          products={products}
          showSaleStockNotice
          showSearchWithinFilter={false}
        />
      </div>
    </FeatureFlagProvider>
  );
};
